import React from "react";
import Routes from "./Routes";
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <Routes />
  );
}

export default App;
